import { translate } from './i18n.js';

const DEFAULT_DISCIPLINES = [
    'kendo',
    'iaido',
    'jodo',
    'kyudo',
    'naginata',
    'battodo',
    'chanbara'
];

export class CalendarSubscriptions {
    constructor(app) {
        this.app = app;
    }

    getContents() {
        return {
            subscribe: {
                titleKey: 'mainMenu.subscribe',
                icon: '/images/subscribe-grey.svg',
                path: 'subscribe',
                attachedLabel: true,
                render: (context) => this.render(context)
            }
        };
    }

    open(returnFocus = null) {
        return this.app?.simpleModal?.open('subscribe', returnFocus) || false;
    }

    render(context) {
        const { body, locale } = context;
        const introTitle = document.createElement('h3');
        const intro = document.createElement('p');
        const list = document.createElement('div');

        body.classList.add('calendar-subscriptions-body');
        introTitle.className = 'calendar-subscription-title';
        introTitle.textContent = translate('calendarSubscriptions.howItWorksTitle', locale);
        intro.className = 'calendar-subscriptions-intro';
        intro.textContent = translate('calendarSubscriptions.intro', locale);
        list.className = 'calendar-subscriptions-list';
        list.append(
            this.createCalendarItem('all', translate('calendarSubscriptions.allTitle', locale), translate('calendarSubscriptions.allDescription', locale), locale),
            ...this.getDisciplines().map((discipline) => {
                const label = translate(`calendarSubscriptions.disciplines.${discipline}`, locale);

                return this.createCalendarItem(
                    discipline,
                    label,
                    translate('calendarSubscriptions.disciplineDescription', locale, { discipline: label }),
                    locale
                );
            })
        );

        body.replaceChildren(introTitle, intro, list);
    }

    createCalendarItem(id, titleText, descriptionText, locale) {
        const article = document.createElement('article');
        const header = document.createElement('div');
        const heading = document.createElement('div');
        const titleIcon = document.createElement('img');
        const title = document.createElement('h4');
        const leader = document.createElement('span');
        const description = document.createElement('p');
        const actions = document.createElement('div');
        const calendarUrl = this.getCalendarUrl(id);

        article.className = 'calendar-subscription-item';
        header.className = 'calendar-subscription-header';
        heading.className = 'calendar-subscription-heading';
        titleIcon.className = 'calendar-subscription-title-icon';
        titleIcon.src = '/images/subscribe-grey.svg';
        titleIcon.alt = '';
        titleIcon.setAttribute('aria-hidden', 'true');
        title.className = 'calendar-subscription-item-title';
        title.textContent = titleText;
        leader.className = 'calendar-subscription-leader';
        leader.setAttribute('aria-hidden', 'true');
        description.className = 'calendar-subscription-description';
        description.textContent = descriptionText;
        actions.className = 'calendar-subscription-actions';
        actions.append(
            this.createAction(
                this.toWebcalUrl(calendarUrl),
                translate('calendarSubscriptions.subscribeAction', locale)
            )
        );
        heading.append(titleIcon, title);
        header.append(heading, leader, actions);
        article.append(header, description);

        return article;
    }

    createAction(href, labelText) {
        const link = document.createElement('a');
        const label = document.createElement('span');

        link.className = 'ui-buttons square medium';
        link.href = href;
        label.textContent = labelText;
        link.append(label);

        return link;
    }

    getDisciplines() {
        const configured = this.app?.config?.calendar?.disciplines;

        return Array.isArray(configured)
            ? configured
            : DEFAULT_DISCIPLINES;
    }

    getCalendarUrl(id) {
        const baseUrl = String(this.app?.config?.calendar?.public_url || '/calendar/public').replace(/\/$/, '');

        return new URL(`${baseUrl}/${encodeURIComponent(id)}.ics`, window.location.origin).href;
    }

    toWebcalUrl(url) {
        return url.replace(/^https?:/i, 'webcal:');
    }
}
